import React, { useState, useRef, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './Strength.css';

import defaultImage from '../../../../../assets/StrengthOfRadixIcons/BOMIcon.svg';  
import {fetchRadixStrengths } from '../../../../../services/radix/radixServices';


const MainContainer = ({ children }) => {
  return <div className="main-container">{children}</div>;
};

const Header = () => {
  return (
    <header className="header-h1">
      <h1>Strength of Radix Software</h1>
    </header>
  );
};

const FeatureSection = ({ showMore, featureRef, isMobile,features }) => {
  
  const formattedFeatures = features.map((item) => ({
    key: item.id,
    img: `${process.env.REACT_APP_STRAPI_API_BASE_URL}${item?.Img?.url}`|| defaultImage,
    title: item.Title,
    description: item.Description,
  }));
  
  const visibleFeatures = showMore ? formattedFeatures : formattedFeatures.slice(0, 6);

  if (isMobile) {
    return (
      <div className="carousel-container">
        <Carousel
          showArrows={true}
          showStatus={false}
          showIndicators={true}
          showThumbs={false}
          autoPlay
          interval={3000}
          infiniteLoop
        >
          {formattedFeatures.map((feature) => (
            <FeatureBox key={feature.key} img={feature.img} title={feature.title} description={feature.description} />
          ))}
        </Carousel>
      </div>
    );
  }

  return (
    <section className="feature-section" ref={featureRef}>
      {visibleFeatures.map((feature, index) => (
        <FeatureBox key={feature.key} img={feature.img} title={feature.title} description={feature.description} />
      ))}
    </section>
  );
};

const FeatureBox = ({ title, description, img }) => {
  return (
    <div className="feature-box">
      <img src={img} alt={title} />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

const ToggleButton = ({ showMore, onClick }) => {
  return (
    <button className="toggle-button" onClick={onClick}>
      {showMore ? 'Show Less' : 'Show More'}
    </button>
  );
};

const Strength = () => {
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const featureRef = useRef(null);


  const handleToggle = () => {
    setShowMore((prevShowMore) => {
      if (prevShowMore) {
        featureRef.current.scrollIntoView({ behavior: 'smooth' });
      }
      return !prevShowMore;
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [features,setFeatures]=useState([]);

  useEffect(()=>{
    const loadRadixStrength=async ()=> {
      const data =await fetchRadixStrengths();
      setFeatures(data);
    }
    loadRadixStrength()
    const url=`${features[0]?.Img?.url}`;
    console.log(`${process.env.REACT_APP_STRAPI_API_BASE_URL}${url}`);
    
  },[])

  return (
    <MainContainer >
      <Header />
      <FeatureSection showMore={showMore} featureRef={featureRef} isMobile={isMobile}  features={features}/>
      {!isMobile && <ToggleButton showMore={showMore} onClick={handleToggle} />}
    </MainContainer>
  );
};

export default Strength;
